import Controller from 'controllers/controller';
import Binder from 'tools/binder';
import Helpers from 'tools/helpers';
import createParallax from 'tools/parallax';

class ParallaxController extends Controller {
    constructor(app) {
        super(app);
        
        this.binder = new Binder(this);
        this.parallax = null;
        
        if (this.app.breakpointController.gt('md')) {
            this.parallax = createParallax(this);
        }
        
        this.attachEvents();
    }
    
    attachEvents() {
        this.app.loaderController.on('page-loaded', Helpers.throttledFunction(250, this.binder.bind('onPageLoaded')));
        window.addEventListener('resize', Helpers.throttledFunction(250, this.binder.bind('resize')));
    }

    onPageLoaded() {
        this.update();
    }
    
    resize() {
        if (this.parallax) {
            this.parallax.resize();
        }
    }
    
    cacheElements() {
        if (this.parallax) {
            this.parallax.cacheElements();
        }
    }
    
    update() {
        this.cacheElements();
        this.resize();
    }
}

export default ParallaxController;